export default __webpack_public_path__ + "static/media/phoenix.f7ed9e16.png";